import axios from 'axios';

export const APP_API_URL = (url = '') => {

    let frontPortLen = (process.env.VUE_APP_DEV_FRONT_PORT.length) * -1;
    let apiURL = (process.env.VUE_APP_NODE_ENV == 'development') ?
        (document.location.origin.slice(0, frontPortLen) + process.env.VUE_APP_DEV_API_PORT) : (document.location.origin + ':' + process.env.VUE_APP_PRD_API_PORT);

    return apiURL + url
}

export const getRequest = function(url, params = {}, configs = {}) {
    const request = axios.get(APP_API_URL(url), {
        withCredentials: true,
        params: params,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
                'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
                'Origin, Content-Type, X-Auth-Token',
            ...configs
        }
    });

    return request;
};

export const postRequest = function(url, body = {}, configs = {}) {
    const request = axios.post(APP_API_URL(url), body, {
        withCredentials: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
                'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
                'Origin, Content-Type, X-Auth-Token',
            ...configs
        }
    });

    return request;
};

export const putRequest = function(url, body = {}, configs = {}) {
    const request = axios.put(APP_API_URL(url), body, {
        withCredentials: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
                'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
                'Origin, Content-Type, X-Auth-Token',
            ...configs
        }
    });

    return request;
};

export const patchRequest = function(url, body = {}, configs = {}) {
    const request = axios.patch(APP_API_URL(url), body, {
        withCredentials: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
                'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
                'Origin, Content-Type, X-Auth-Token',
            ...configs
        }
    });

    return request;
};

export const deleteRequest = function(url, body = {}, configs = {}) {
    const request = axios.delete(APP_API_URL(url),
        {
            withCredentials: true,
            data: body,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods':
                    'GET, POST, PATCH, PUT, DELETE, OPTIONS',
                'Access-Control-Allow-Headers':
                    'Origin, Content-Type, X-Auth-Token',
                ...configs
            }
        });

    return request;
};